const UploadIcon = ({ width = 70, height = 63, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 63 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.7485 8.51145C50.4084 3.54011 60.1137 9.33579 60.1137 15.4046C60.1137 19.324 58.591 20.8614 56.2326 22.5C68.1271 28.7761 62.7438 42.6585 52.3669 45H16.1244C-0.897042 45 -7.19294 22.2471 10.9308 16.7346C7.53167 3.36816 34.0944 -8.6986 43.7485 8.51145ZM27.3627 35.1686V27.1375H20.0773L31.5053 13.5738L42.9333 27.1375H35.6479V35.1686H27.3627Z"
        fill="#21487D"
      />
    </svg>
  )
}

export default UploadIcon
